import { i18nClient } from "@/i18n";

export const FONT_COLOR_DARK = "#333";
export const FONT_COLOR_LIGHT = "#fff";

export const colorsMore = [
  "#fff",
  "#333",
  "#f5222d",
  "#fa541c",
  "#faad14",
  "#fadb14",
  "#52c41a",
  "#13c2c2",
  "#1890ff",
  "#2f54eb",
  "#722ed1",
  "#eb2f96",
  "#f6f6f6",
  "#989898",
  "#ffe8e7",
  "#ffece0",
  "#fff7cb",
  "#fcfcca",
  "#e5f7d3",
  "#cffff7",
  "#d4eefc",
  "#dfe8fc",
  "#efe1fa",
  "#fbe1eb",
  "#e9e9e9",
  "#666",
  "#ffa39e",
  "#ffbb96",
  "#ffe58f",
  "#fffb8f",
  "#b7eb8f",
  "#87e8de",
  "#91d5ff",
  "#adc6ff",
  "#d3adf7",
  "#ffadd2",
  "#ddd",
  "#4b4b4b",
  "#ff4d4f",
  "#ff7a45",
  "#ffc53d",
  "#ffec3d",
  "#73d13d",
  "#36cfc9",
  "#40a8ff",
  "#597ef7",
  "#9254de",
  "#f759ab",
  "#ccc",
  "#262626",
  "#cf1322",
  "#d4380d",
  "#d48806",
  "#d4b106",
  "#389e0d",
  "#08979c",
  "#096dd9",
  "#1d39c4",
  "#531dab",
  "#c41d7f",
  "#aaa",
  "#000",
  "#820014",
  "#871400",
  "#874d00",
  "#876800",
  "#135200",
  "#00474f",
  "#003a8c",
  "#061178",
  "#22075e",
  "#780650",
];

export const colors = ["#ccc", "#f5222d", "#fadb14", "#52c41a", "#1890ff"];

export const patterns = [
  { type: "fill", text: i18nClient.t("fill_in", "填充") },
  { type: "outline", text: i18nClient.t("wire_frame", "线框") },
];

interface ColorsMap {
  [key: string]: string;
}

export const colorsMap: ColorsMap = {
  gray: "#ccc",
  red: "#f5222d",
  yellow: "#fadb14",
  green: "#52c41a",
  blue: "#1890ff",
};
